import { useMutation, useQueryClient } from "@tanstack/react-query";
import { gymsService } from "@/api/gymsService";

export const useUpdateUiFlags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: gymsService.updateUiFlags,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fitnessCenter"] });
    },
  });
};
